/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wc_Vs_Migrate3Inputs */

const en_wc_vs_migrate3 = /** @type {(inputs: Wc_Vs_Migrate3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rely on Styles rather than manual formatting; styled documents convert most cleanly.`)
};

/**
* | output |
* | --- |
* | "Rely on Styles rather than manual formatting; styled documents convert most cleanly." |
*
* @param {Wc_Vs_Migrate3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const wc_vs_migrate3 = /** @type {((inputs?: Wc_Vs_Migrate3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wc_Vs_Migrate3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_wc_vs_migrate3(inputs)
});
export { wc_vs_migrate3 as "wc.vs.migrate3" }